import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import UpcominMatches from "../Match/components/UpcominMatches";
import MatchList from '../Match/components/MatchList';
import { loaderStateFalse, loaderStateTrue } from '../../slices/mainSlice';
import { getMatchListApi } from '../Match/MatchController';

function Preview() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { language } = useSelector((state) => state.language);
    const { userDetails, token, userType } = useSelector((state) => state.user);

    const [matchList, setMatchList] = useState([]);

    const getMatchList = () => {
        try {
            dispatch(loaderStateTrue());
            getMatchListApi()
                .then((response) => {
                    let responseData = response.data?.result || [];
                    console.log("responseDataresponseDataresponseData", responseData)
                    setMatchList(responseData);
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    return (
        <main className="main p-4 relative">
            <div className="flex flex-col">
                <div className="flex flex-wrap items-start gap-y-6 -mx-2">
                    <div className="lg:w-4/6 w-full px-2">
                        <div className="space-y-5">
                            <div className="relative">
                                <div className="relative rounded-xl bg-gray-50 h-full">
                                    <div className='absolute inset-0 rounded-xl overflow-hidden'>
                                        <div className="w-[8vw] h-[8vw] rounded-[50%] bg-[#F022AC] blur-[80px] absolute -top-[1vw] -right-[2vw] opacity-80"></div>
                                        <div className="w-[16vw] h-[16vw] rounded-[50%] bg-[#FB4A4A] blur-[80px] absolute -top-[6vw] right-[5vw]"></div>
                                        <div className="w-[10vw] h-[10vw] rounded-[50%] bg-[#0198FF] blur-[100px] absolute -bottom-[6vw] right-[15vw]"></div>
                                    </div>
                                    <div className="flex max-sm:flex-wrap gap-3 justify-between relative">
                                        <div className="p-5 flex flex-col items-start justify-center [&_h1_strong]:text-primary-500 space-y-3 [&_strong]:text-primary-500">
                                            <div className="space-y-2">
                                                <h2 className="lg:text-4xl md:text-3xl text-xl font-black uppercase">fixture  management</h2>
                                                <p className='text-base font-medium text-gray-400'>Dummy text of the printing and typesetting industry.</p>
                                            </div>
                                        </div>
                                        <div className="lg:-mt-4 text-center">
                                            <img src="assets/images/teams.png" alt="" className="w-full inline-block rounded-br-xl" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex justify-between items-center gap-3">
                                <div>
                                    <h3 className="xl:text-2xl text-xl font-extrabold uppercase">Select Team formation</h3>
                                    <p className='text-gray-400'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </div>
                                <select className="form-select font-bold !max-w-[200px]">
                                    <option value="">4-4-3</option>
                                    <option value="">3-4-3</option>
                                    <option value="">4-3-4</option>
                                </select>
                            </div>

                            <div className="'w-full px-2">
                                <label className='form-label'>Add Players</label>
                                <div className="relative">
                                    <img src="assets/images/football-ground.png" alt="" className="opacity-50" />
                                    <div className="px-16 py-5 absolute inset-0 w-[92%]">
                                        <div className="flex justify-center items-center h-full w-full">
                                            <div className="w-1/4 px-2 space-y-2">
                                                <div className="relative">
                                                    <div className="md:size-[5vw] size-[8vw] mx-auto relative text-center">
                                                        <button className="absolute top-0 right-0 size-5 rounded-full bg-red-500 flex justify-center items-center">
                                                            <img src="assets/images/icons/minus.svg" alt="" className="w-full icon-white" />
                                                        </button>
                                                        <div className="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
                                                            <img src="assets/images/players-list/1.png" alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="absolute font-secondary font-semibold uppercase mt-1 left-0 right-0 text-center">
                                                        Add Player
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="w-1/4 px-2 md:space-y-8 space-y-3">
                                                <div className="relative">
                                                    <div className="md:size-[5vw] size-[8vw] mx-auto relative text-center">
                                                        <button className="absolute top-0 right-0 size-5 rounded-full bg-red-500 flex justify-center items-center">
                                                            <img src="assets/images/icons/minus.svg" alt="" className="w-full icon-white" />
                                                        </button>
                                                        <div className="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
                                                            <img src="assets/images/players-list/2.png" alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="absolute font-secondary font-semibold uppercase mt-1 left-0 right-0 text-center">
                                                        Add Player
                                                    </div>
                                                </div>

                                                <div className="relative">
                                                    <div className="md:size-[5vw] size-[8vw] mx-auto relative text-center">
                                                        <button className="absolute top-0 right-0 size-5 rounded-full bg-red-500 flex justify-center items-center">
                                                            <img src="assets/images/icons/minus.svg" alt="" className="w-full icon-white" />
                                                        </button>
                                                        <div className="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
                                                            <img src="assets/images/players-list/3.png" alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="absolute font-secondary font-semibold uppercase mt-1 left-0 right-0 text-center">
                                                        Add Player
                                                    </div>
                                                </div>

                                                <div className="relative">
                                                    <div className="md:size-[5vw] size-[8vw] mx-auto relative text-center">
                                                        <button className="absolute top-0 right-0 size-5 rounded-full bg-red-500 flex justify-center items-center">
                                                            <img src="assets/images/icons/minus.svg" alt="" className="w-full icon-white" />
                                                        </button>
                                                        <div className="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
                                                            <img src="assets/images/players-list/4.png" alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="absolute font-secondary font-semibold uppercase mt-1 left-0 right-0 text-center">
                                                        Add Player
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-2 md:space-y-8 space-y-3">
                                                <div className="relative">
                                                    <div className="md:size-[5vw] size-[8vw] mx-auto relative text-center">
                                                        <button className="absolute top-0 right-0 size-5 rounded-full bg-red-500 flex justify-center items-center">
                                                            <img src="assets/images/icons/minus.svg" alt="" className="w-full icon-white" />
                                                        </button>
                                                        <div className="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
                                                            <img src="assets/images/players-list/5.png" alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="absolute font-secondary font-semibold uppercase mt-1 left-0 right-0 text-center">
                                                        Add Player
                                                    </div>
                                                </div>

                                                <div className="relative">
                                                    <div className="md:size-[5vw] size-[8vw] mx-auto relative text-center">
                                                        <button className="absolute top-0 right-0 size-5 rounded-full bg-red-500 flex justify-center items-center">
                                                            <img src="assets/images/icons/minus.svg" alt="" className="w-full icon-white" />
                                                        </button>
                                                        <div className="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
                                                            <img src="assets/images/players-list/6.png" alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="absolute font-secondary font-semibold uppercase mt-1 left-0 right-0 text-center">
                                                        Add Player
                                                    </div>
                                                </div>

                                                <div className="relative">
                                                    <div className="md:size-[5vw] size-[8vw] mx-auto relative text-center">
                                                        <button className="absolute top-0 right-0 size-5 rounded-full bg-red-500 flex justify-center items-center">
                                                            <img src="assets/images/icons/minus.svg" alt="" className="w-full icon-white" />
                                                        </button>
                                                        <div className="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
                                                            <img src="assets/images/players-list/1.png" alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="absolute font-secondary font-semibold uppercase mt-1 left-0 right-0 text-center">
                                                        Add Player
                                                    </div>
                                                </div>

                                                <div className="relative">
                                                    <div className="md:size-[5vw] size-[8vw] mx-auto relative text-center">
                                                        <button className="absolute top-0 right-0 size-5 rounded-full bg-red-500 flex justify-center items-center">
                                                            <img src="assets/images/icons/minus.svg" alt="" className="w-full icon-white" />
                                                        </button>
                                                        <div className="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
                                                            <img src="assets/images/players-list/2.png" alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="absolute font-secondary font-semibold uppercase mt-1 left-0 right-0 text-center">
                                                        Add Player
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="w-1/4 px-2 md:space-y-8 space-y-3">
                                                <div className="relative">
                                                    <div className="md:size-[5vw] size-[8vw] mx-auto relative text-center">
                                                        <button className="absolute top-0 right-0 size-5 rounded-full bg-red-500 flex justify-center items-center">
                                                            <img src="assets/images/icons/minus.svg" alt="" className="w-full icon-white" />
                                                        </button>
                                                        <div className="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
                                                            <img src="assets/images/players-list/3.png" alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="absolute font-secondary font-semibold uppercase mt-1 left-0 right-0 text-center">
                                                        Add Player
                                                    </div>
                                                </div>

                                                <div className="relative">
                                                    <div className="md:size-[5vw] size-[8vw] mx-auto relative text-center">
                                                        <button className="absolute top-0 right-0 size-5 rounded-full bg-red-500 flex justify-center items-center">
                                                            <img src="assets/images/icons/minus.svg" alt="" className="w-full icon-white" />
                                                        </button>
                                                        <div className="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
                                                            <img src="assets/images/players-list/4.png" alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="absolute font-secondary font-semibold uppercase mt-1 left-0 right-0 text-center">
                                                        Add Player
                                                    </div>
                                                </div>

                                                <div className="relative">
                                                    <div className="md:size-[5vw] size-[8vw] mx-auto relative text-center">
                                                        <button className="absolute top-0 right-0 size-5 rounded-full bg-red-500 flex justify-center items-center">
                                                            <img src="assets/images/icons/minus.svg" alt="" className="w-full icon-white" />
                                                        </button>
                                                        <div className="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
                                                            <img src="assets/images/players-list/5.png" alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="absolute font-secondary font-semibold uppercase mt-1 left-0 right-0 text-center">
                                                        Add Player
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-wrap items-start gap-4 p-3 rounded-lg bg-gray-50">
                                <div>
                                    <h3 className="text-lg font-extrabold uppercase">Manage team</h3>
                                    <p className="text-gray-400">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </div>
                                <button onClick={() => navigate(`/${language}/fixtures/information-with-team`)} className="btn btn-primary text-nowrap ml-auto">Proceed</button>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-2/6 w-full px-2 space-y-8 sticky top-20">
                        <div className="panel rounded-xl border light-border bg-white p-4 space-y-4">
                            <div className="panel-header w-full flex flex-wrap justify-between items-center gap-3">
                                <h3 className="xl:text-lg text-base font-extrabold uppercase">{t('upcomingMatches')}</h3>
                                <Link to={'../upcoming-matches'} className="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</Link>
                            </div>
                            <div className="panel-body w-full">
                                <MatchList matchList={matchList} isUpcomming={true} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Preview